import { render, staticRenderFns } from "./UpdateHealthInsuranceDialog.vue?vue&type=template&id=eb7eb75a&"
import script from "./UpdateHealthInsuranceDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateHealthInsuranceDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports